import { PartnerEmail } from '@/types/partner';

const INVITE_VALIDITY_MS = 24 * 60 * 60 * 1000;

export function getClientDisplayName(client: PartnerEmail): string {
  if (client.name?.trim()) return client.name.trim();
  const localPart = client.email.split('@')[0] ?? client.email;
  return localPart
    .split(/[._-]/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function getClientStatus(client: PartnerEmail): 'ACTIVE' | 'PENDING' {
  return client.status ?? 'PENDING';
}

export function isInviteWithinValidity(client: PartnerEmail): boolean {
  if (!client.created_at) return false;
  return Date.now() - new Date(client.created_at).getTime() < INVITE_VALIDITY_MS;
}

export function formatClientDateTime(dateString?: string): string {
  if (!dateString) return '—';
  const date = new Date(dateString);
  return date.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
